import { readFileSync } from "fs"
import { dirname, join } from "path"
import { fileURLToPath } from "url"

const Filename = fileURLToPath(import.meta.url)
const Dirname = dirname(Filename)

export function getVersion(): string {
  try {
    const packageJsonPath = join(Dirname, "../../package.json")
    const packageJson = JSON.parse(readFileSync(packageJsonPath, "utf-8"))
    return packageJson.version
  } catch {
    return "0.0.0"
  }
}

export const version = getVersion()
